import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import {
  Paper,
  Button,
  Breadcrumbs,
  Typography,
  TextField,
  Container,
  Grid,
  Box,
  MenuItem,
  IconButton,
  Pagination,
  useMediaQuery,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { Link } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import { getName } from "../Other/common";
import { toast } from "react-toastify";
import { useTheme } from "@emotion/react";
import { Select, FormControl, InputLabel } from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import DownloadIcon from "@mui/icons-material/Download";
import LoaderSpin from "../LoaderSpin";
import PrintIcon from "@mui/icons-material/Print";

import * as XLSX from "xlsx";
import Barcode from "react-barcode";
import { useReactToPrint } from "react-to-print";
import { BASE_URL } from "../../urlConfig/Url";
import QRCode from "react-qr-code";

const PrintableBarcodes = React.forwardRef(({ barcodes }, ref) => (
  <div ref={ref}>
    {barcodes.map((barcode, index) => (
      <div
        key={index}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "20px",
          pageBreakAfter: "always",
        }}
      >
        <div style={{ marginRight: "20px" }}>
          <QRCode value={barcode.barcode} />
        </div>
        <div style={{ textAlign: "left" }}>
          <p style={{ fontSize: "16px", fontWeight: "bold" }}>Plant Code: {barcode.plantCode}</p>
          <p style={{ fontSize: "16px", fontWeight: "bold" }}>Asset Code: {barcode.assetCode}</p>
        </div>
      </div>
    ))}
  </div>
));

const PrintAssetBarcode = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [id, setId] = useState("");
  const [plantCode, setPlantCode] = useState("");
  const [assetCode, setAssetCode] = useState("");
  const [pQty, setPQty] = useState("");
  const [editedPendingQty, setEditedPendingQty] = useState({});
  const [originalPendingQty, setOriginalPendingQty] = useState({});

  const [companies, setCompanies] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [cName, setCName] = useState({ plantCodes: [], assetCodes: [] });
  const [cNameTwo, setCNameTwo] = useState([]);
  const [formMode, setFormMode] = useState("initial");
  const [isLoading, setIsLoading] = useState(false);

  const [barcodeResponses, setBarcodeResponses] = useState([]);
  const [selectedBarcodes, setSelectedBarcodes] = useState([]);

  const [rowsPerPage, setRowsPerPage] = useState(5);

  const printableRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => printableRef.current,
  });

  useEffect(() => {
    fetchCompanies();
    fetchCompaniesName();
  }, []);

  useEffect(() => {
    if (plantCode) {
      // Fetch asset codes when plant code changes
      fetchAssetCodes(plantCode);
    } else {
      // Reset asset codes if no plant code is selected
      setCName((prev) => ({ ...prev, assetCodes: [] }));
    }
  }, [plantCode]);

  const fetchCompanies = async () => {
    try {
      const response = await axios.post(
        BASE_URL + "/api/transaction/getAllGenerateAssetMaset"
      );
      if (response.data.success) {
        setCompanies(response.data.response);
      }
    } catch (error) {
      console.error("Error fetching company data:", error);
    }
  };

  const fetchCompaniesName = async () => {
    try {
      const response = await axios.post(
        BASE_URL + "/api/transaction/loadComboPlantAndAsset"
      );
      if (response.data.success) {
        setCName(response.data.response);
      }
    } catch (error) {
      toast.error("Error fetching company data:", error);
    }
  };

  const fetchAssetCodes = async (selectedPlantCode) => {
    try {
      const response = await axios.post(
        BASE_URL + "/api/transaction/searchByPlantCode",
        { plantCode: selectedPlantCode }
      );
      if (response.data.success) {
        setCName((prev) => ({
          ...prev,
          assetCodes: response.data.response.map((item) => item.AssetCode),
        }));
      }
    } catch (error) {
      toast.error("Error fetching asset codes:", error);
    }
  };

  const onSubmit = async () => {
    // if (plantCode === "") {
    //   toast.error("Please select Plant Code!");
    //   return;
    // }
    // if (assetCode === "") {
    //   toast.error("Please Select Asset Code!");
    //   return;
    // }

    const data = {
      plantCode: plantCode,
      assetCode: assetCode,
      // CreatedBy: getName().Name,
    };

    try {
      const response = await axios.post(
        BASE_URL + "/api/transaction/searchByPlantAssetCode",
        data
      );

      if (response.data.success) {
        toast.success(response.data.message);
        setCompanies(response.data.response);
        setFilteredRows(response.data.response);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error submitting company data:", error);
      toast.error("An error occurred while adding the company.");
    }
  };

  const resetForm = () => {
    setPlantCode("");
    setAssetCode("");
  };

  const handleCancel = () => {
    resetForm();
    setFormMode("initial");
    fetchCompanies();
    setBarcodeResponses([]);
  };

  useEffect(() => {
    const searchWords = searchTerm.toLowerCase().split(/\s+/).filter(Boolean);
    
    const result = companies.filter((company) =>
      searchWords.every((word) =>
        Object.entries(company).some(([key, value]) => {
          // Skip null or undefined values
          if (value == null) return false;
  
          // Convert to string and compare
          return value.toString().toLowerCase().includes(word);
        })
      )
    );
    setFilteredRows(result);
  }, [searchTerm, companies]);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setPage(1);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleCheckboxChange = (company) => {
    const isChecked = selectedRows.includes(company.ID);
    if (isChecked) {
      setSelectedRows(selectedRows.filter((id) => id !== company.ID));
    } else {
      setSelectedRows([...selectedRows, company.ID]);
      if (!editedPendingQty[company.ID]) {
        setEditedPendingQty((prev) => ({
          ...prev,
          [company.ID]: company.PendingQty,
        }));
      }
    }
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setSelectedRows(companies.map((company) => company.ID));
    } else {
      setSelectedRows([]);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  /**
   * ============================================Function Generate Barcode ===============================
   *
   */
  const handleGenerateBarcode = async () => {
    const selectedData = companies
      .filter((company) => selectedRows.includes(company.ID))
      .map((company) => ({
        plantCode: company.PlantCode,
        assetCode: company.AssetCode,
        pendingQuantity: parseInt(
          editedPendingQty[company.ID] || company.PendingQty,
          10
        ),
      }));

    const hasInvalidFields = selectedData.some(
      (data) => isNaN(data.pendingQuantity) || data.pendingQuantity <= 0
    );

    if (hasInvalidFields) {
      toast.error(
        "Please enter valid positive numbers for all pending quantities."
      );
      return;
    }

    const apiCalls = [];
    const newBarcodeResponses = [];

    for (const data of selectedData) {
      // console.log(data);
      // First API call to stop asset barcode
      try {
        await axios.post(BASE_URL + "/api/transaction/stopAssetBarcode", {
          assetCode: data.assetCode,
          plantCode: data.plantCode,
          requiredQty: data.pendingQuantity.toString(),
        });
      } catch (error) {
        console.error("Error stopping asset barcode:", error);
        toast.error(`Failed to stop asset barcode for ${data.assetCode}`);
        continue; // Skip to next iteration if stopping fails
      }

      // Generate barcodes
      for (let i = 0; i < data.pendingQuantity; i++) {
        apiCalls.push(
          new Promise((resolve) => {
            setTimeout(() => {
              resolve(
                axios.post(BASE_URL + "/api/transaction/generateAssetBarcode", {
                  plantCode: data.plantCode,
                  assetCode: data.assetCode,
                  user: getName().Name,
                })
              );
            }, i * 200);
          })
        );
      }
    }

    try {
      const responses = await Promise.all(apiCalls);

      const newBarcodeResponses = responses.flatMap((response, index) => {
        if (response.data.success) {
          return [
            {
              id: `${selectedData[0].plantCode}-${selectedData[0].assetCode}-${index}`,
              plantCode: selectedData[0].plantCode,
              assetCode: selectedData[0].assetCode,
              barcode: response.data.response.barcode,
            },
          ];
        }
        return [];
      });

      setBarcodeResponses((prevResponses) => [
        ...prevResponses,
        ...newBarcodeResponses,
      ]);
      toast.success(
        `${newBarcodeResponses.length} barcodes generated successfully.`
      );

      // Clear selected rows and refresh the table
      setSelectedRows([]);
      fetchCompanies();
      resetEditedPendingQty();
    } catch (error) {
      toast.error("An error occurred while generating barcodes.");
      console.error("API Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Add this function to handle single row barcode generation
  const handleGenerateSingleBarcode = async (company) => {
    setIsLoading(true);
    // console.log(company)
    try {
      // First API call to stop asset barcode
      await axios.post(BASE_URL + "/api/transaction/stopAssetBarcode", {
        assetCode: company.AssetCode,
        plantCode: company.PlantCode,
        requiredQty: editedPendingQty[company.ID] || company.PendingQty,
      });

      // Generate barcodes
      const pendingQty = parseInt(
        editedPendingQty[company.ID] || company.PendingQty,
        10
      );
      const responses = await Promise.all(
        Array(pendingQty)
          .fill()
          .map(
            (_, i) =>
              new Promise((resolve) => {
                setTimeout(() => {
                  resolve(
                    axios.post(
                      BASE_URL + "/api/transaction/generateAssetBarcode",
                      {
                        plantCode: company.PlantCode,
                        assetCode: company.AssetCode,
                        user: getName().Name,
                      }
                    )
                  );
                }, i * 200);
              })
          )
      );

      const newBarcodeResponses = responses.flatMap((response, index) => {
        if (response.data.success) {
          return [
            {
              id: `${company.PlantCode}-${company.AssetCode}-${index}`,
              plantCode: company.PlantCode,
              assetCode: company.AssetCode,
              barcode: response.data.response.barcode,
            },
          ];
        }
        return [];
      });

      setBarcodeResponses((prevResponses) => [
        ...prevResponses,
        ...newBarcodeResponses,
      ]);
      toast.success(
        `${newBarcodeResponses.length} barcodes generated successfully.`
      );

      // Refresh the table
      fetchCompanies();
      resetEditedPendingQty();
    } catch (error) {
      toast.error("An error occurred while generating barcodes.");
      console.error("API Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // ============================================Function Generate Barcode ===============================

  const handleBarcodeSelect = (barcodeId) => {
    setSelectedBarcodes((prev) =>
      prev.includes(barcodeId)
        ? prev.filter((id) => id !== barcodeId)
        : [...prev, barcodeId]
    );
  };

  const handleSelectAllBarcodes = (event) => {
    if (event.target.checked) {
      setSelectedBarcodes(barcodeResponses.map((barcode) => barcode.id));
    } else {
      setSelectedBarcodes([]);
    }
  };
  // ====================================handlePrintBarcodes==============
  const handlePrintBarcodes = async () => {
    if (selectedBarcodes.length === 0) {
      toast.error("Please select barcodes to print");
      return;
    }

    const selectedBarcodeData = barcodeResponses.filter((barcode) =>
      selectedBarcodes.includes(barcode.id)
    );

    for (let i = 0; i < selectedBarcodeData.length; i++) {
      const barcode = selectedBarcodeData[i];
      const data = {
        uniqueCode: barcode.barcode,
        user: getName().Name,
        qrCodeImage: "data:image/png;base64," + barcode.barcode,
      };

      try {
        await new Promise((resolve) => setTimeout(resolve, 200));
        const response = await axios.post(
          BASE_URL + "/api/transaction/updatePrintStatus",
          data
        );
        if (!response.data.success) {
          toast.error(
            `Failed to update reprint flag for barcode: ${barcode.barcode}`
          );
        }
      } catch (error) {
        console.error("Error updating reprint flag:", error);
        toast.error(
          `Error updating reprint flag for barcode: ${barcode.barcode}`
        );
      }
    }

    handlePrint();

    // Remove printed barcodes from the table
    setBarcodeResponses((prevResponses) =>
      prevResponses.filter((barcode) => !selectedBarcodes.includes(barcode.id))
    );

    // Clear the selection after printing
    setSelectedBarcodes([]);

    toast.success(
      `Printed ${selectedBarcodeData.length} barcodes successfully`
    );

    // Refresh the main table
    fetchCompanies();
  };

  const handleExportToExcel = async () => {
    const dataToExport = barcodeResponses.filter((barcode) =>
      selectedBarcodes.includes(barcode.id)
    );

    for (const barcode of dataToExport) {
      try {
        await axios.post(BASE_URL + "/api/transaction/exportStatusUpdate", {
          barcode: barcode.barcode,
        });
      } catch (error) {
        console.error(
          `Error updating export status for barcode ${barcode.barcode}:`,
          error
        );
        // Optionally, you can show an error toast here
      }
    }

    // Proceed with Excel export
    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Generated Barcodes");
    XLSX.writeFile(workbook, "GeneratedBarcodes.xlsx");

    toast.success(`Exported ${dataToExport.length} barcodes successfully`);
  };

  const paginatedRows = filteredRows.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  const handlePendingQtyChange = (id, value) => {
    setEditedPendingQty((prev) => ({
      ...prev,
      [id]: value,
    }));
  };
  const resetEditedPendingQty = () => {
    setEditedPendingQty({});
  };
  return (
    <>
      {/* <LoaderSpin show={false} /> */}
      <Container maxWidth="lg">
        <Box sx={{ mt: 1, mb: 2 }}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link
              to="/dashboard/dashbordhome"
              style={{
                textDecoration: "none",
                color: theme.palette.primary.main,
              }}
            >
              Home
            </Link>
            <Typography color="textPrimary">Print Asset Barcode</Typography>
          </Breadcrumbs>
        </Box>

        <Box sx={{ mt: 3, overflowX: "auto" }}>
          <Paper elevation={3} sx={{ padding: "2%" }}>
            <Typography variant="h6" mb={2} sx={{ textAlign: "left" }}>
              Print Asset Barcode
            </Typography>

            <Grid container spacing={3}>
              <Grid item xs={10} sm={3}>
                <TextField
                  select
                  label="Plant Code"
                  name="Plant Code"
                  fullWidth
                  size="small"
                  value={plantCode}
                  onChange={(e) => setPlantCode(e.target.value)}
                >
                  {cName.plantCodes.map((code) => (
                    <MenuItem key={code} value={code}>
                      {code}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={10} sm={3}>
                <TextField
                  select
                  label="Asset Code"
                  name="Asset Code"
                  fullWidth
                  size="small"
                  value={assetCode}
                  onChange={(e) => setAssetCode(e.target.value)}
                >
                  {cName.assetCodes.length === 0 ? (
                    <MenuItem value="" disabled>
                      No Asset Codes Available
                    </MenuItem>
                  ) : (
                    cName.assetCodes.map((code) => (
                      <MenuItem key={code} value={code}>
                        {code}
                      </MenuItem>
                    ))
                  )}
                </TextField>
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent={{ sx: "center", sm: "flex-end" }}
              mt={5}
              spacing={1}
            >
              <Grid item>
                <Button variant="contained" size="small" onClick={onSubmit}>
                  <AddIcon />
                  Search
                </Button>
              </Grid>
              <Grid item>
                <Button variant="contained" size="small" onClick={handleCancel}>
                  <CloseIcon />
                  Cancel
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </Box>

        <Box sx={{ mt: 3, overflowX: "auto" }}>
          <Paper elevation={3} sx={{ padding: "2%" }}>
            <Box
              sx={{
                mb: 2,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <FormControl
                variant="outlined"
                size="small"
                sx={{ minWidth: 100 }}
              >
                <InputLabel id="rows-per-page-label">Rows per page</InputLabel>
                <Select
                  labelId="rows-per-page-label"
                  value={rowsPerPage}
                  onChange={handleChangeRowsPerPage}
                  label="Rows per page"
                >
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                </Select>
              </FormControl>
              <TextField
                label="Search"
                variant="outlined"
                size="small"
                value={searchTerm}
                onChange={handleSearchChange}
                sx={{ width: 250 }}
                InputProps={{
                  endAdornment: (
                    <IconButton>
                      <SearchIcon />
                    </IconButton>
                  ),
                }}
              />
            </Box>
            <div className="table-container">
              <table className="responsive-table">
                <thead>
                  <tr>
                    <th>
                      <Checkbox
                        style={{ color: "white" }}
                        checked={
                          selectedRows.length === filteredRows.length &&
                          selectedRows.length > 0
                        }
                        indeterminate={
                          selectedRows.length > 0 &&
                          selectedRows.length < filteredRows.length
                        }
                        onChange={handleSelectAll}
                      />
                    </th>
                    <th>Plant Code</th>
                    <th>Asset Code</th>
                    <th>Description</th>
                    <th>Category</th>
                    <th>Depreciation</th>
                    <th>Depreciation Year</th>
                    <th>Status</th>
                    <th>Total Quantity</th>
                    <th>Printed Quantity</th>
                    <th>Print Pending Quantity</th>
                  </tr>
                </thead>
                <tbody style={{ textAlign: "center" }}>
                  {filteredRows.map((company) => (
                    <tr key={company.ID}>
                      <td data-label="Select">
                        <Checkbox
                          checked={selectedRows.includes(company.ID)}
                          onChange={() => handleCheckboxChange(company)}
                        />
                      </td>
                      <td data-label="Plant Code">{company.PlantCode}</td>
                      <td data-label="Asset Code">{company.AssetCode}</td>
                      <td data-label="Description">{company.Description}</td>
                      <td data-label="Category">{company.Category}</td>
                      <td data-label="Depreciation">{company.Depreciation}%</td>
                      <td data-label="Depreciation Year">
                        {company.DepreciationYear}
                      </td>
                      <td data-label="Status">{company.Status}</td>
                      <td data-label="Total Quantity">{company.Quantity}</td>
                      <td data-label="Printed Quantity">
                        {company.Quantity - company.PendingQty}
                      </td>
                      <td data-label="Print Pending Quantity">
                        <span>
                          <TextField
                            size="small"
                            value={
                              editedPendingQty[company.ID] !== undefined
                                ? editedPendingQty[company.ID]
                                : company.PendingQty
                            }
                            onChange={(e) =>
                              handlePendingQtyChange(company.ID, e.target.value)
                            }
                          />
                          <Button
                            variant="outlined"
                            size="small"
                            onClick={() => handleGenerateSingleBarcode(company)}
                            sx={{ ml: 1 }}
                          >
                            Generate
                          </Button>
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <Box
              sx={{
                mt: 2,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box>
                <Button
                  variant="contained"
                  size="small"
                  startIcon={<DownloadIcon />}
                  onClick={handleGenerateBarcode}
                  disabled={selectedRows.length === 0}
                >
                  Generate Barcode
                </Button>
                {/* <Button
                  variant="contained"
                  size="small"
                  startIcon={<DownloadIcon />}
                  disabled={selectedRows.length === 0}
                  sx={{ ml: 2 }}
                >
                  Export to Excel
                </Button> */}
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography variant="body2" sx={{ marginRight: 2 }}>
                  Showing {(page - 1) * rowsPerPage + 1} to{" "}
                  {Math.min(page * rowsPerPage, filteredRows.length)} of{" "}
                  {filteredRows.length} entries
                </Typography>
                <Pagination
                  count={Math.ceil(filteredRows.length / rowsPerPage)}
                  page={page}
                  onChange={handleChangePage}
                  size="small"
                />
              </Box>
            </Box>
          </Paper>
        </Box>
        <LoaderSpin show={isLoading} />
        {barcodeResponses.length > 0 && (
          <Box sx={{ mt: 3, overflowX: "auto" }}>
            <Paper elevation={3} sx={{ padding: "2%" }}>
              <Typography variant="h6" mb={2} sx={{ textAlign: "left" }}>
                Generated Barcodes
              </Typography>
              <div className="table-container">
                <table className="responsive-table">
                  <thead>
                    <tr>
                      <th>
                        <Checkbox
                          sx={{ color: "white" }}
                          checked={
                            selectedBarcodes.length ===
                              barcodeResponses.length &&
                            barcodeResponses.length > 0
                          }
                          indeterminate={
                            selectedBarcodes.length > 0 &&
                            selectedBarcodes.length < barcodeResponses.length
                          }
                          onChange={handleSelectAllBarcodes}
                        />
                      </th>

                      <th>Plant Code</th>
                      <th>Asset Code</th>
                      <th>Barcode</th>
                      <th>Preview</th>
                    </tr>
                  </thead>
                  <tbody>
                    {barcodeResponses.map((barcode, i) => (
                      <tr key={barcode.id}>
                        <td>
                          <Checkbox
                            checked={selectedBarcodes.includes(barcode.id)}
                            onChange={() => handleBarcodeSelect(barcode.id)}
                          />
                        </td>

                        <td data-label="Plant Code">{barcode.plantCode}</td>
                        <td data-label="Asset Code">{barcode.assetCode}</td>
                        <td data-label="Barcode">{barcode.barcode}</td>
                        <td data-label="Preview">
                          <Barcode
                            value={barcode.barcode}
                            width={1}
                            height={30}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<PrintIcon />}
                  onClick={handlePrintBarcodes}
                  disabled={selectedBarcodes.length === 0}
                  sx={{ mr: 2 }}
                >
                  Print Selected Barcodes
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  startIcon={<DownloadIcon />}
                  onClick={handleExportToExcel}
                  disabled={selectedBarcodes.length === 0}
                >
                  Export to Excel
                </Button>
              </Box>
            </Paper>
          </Box>
        )}
      </Container>
      <div style={{ display: "none" }}>
        <PrintableBarcodes
          ref={printableRef}
          barcodes={barcodeResponses.filter((barcode) =>
            selectedBarcodes.includes(barcode.id)
          )}
        />
      </div>
    </>
  );
};

export default PrintAssetBarcode;
